/* ==========================================================================
   Catchy Search — results page (filters, sort, swatches)
   Uses window.CatchySearch from catchy-search.js
   ========================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('.csr');
  if (!root) return;
  var cfg = JSON.parse(root.querySelector('.csr-config').textContent);
  var T = cfg.t;
  var q$ = function (s) { return root.querySelector(s); };
  var el = {
    title: q$('.csr-title'), sub: q$('.csr-sub'), dym: q$('.csr-dym'), searchForm: q$('.csr-search'), searchInput: q$('.csr-search-input'),
    filterBtn: q$('.csr-filter-btn'), filterCount: q$('.csr-filter-count'), active: q$('.csr-active'), sortWrap: q$('.csr-sort'), sortBtn: q$('.csr-sort-btn'), sortMenu: q$('.csr-sort-menu'), sortCur: q$('.csr-sort-current'), sortScrim: q$('.csr-sort-scrim'),
    filters: q$('.csr-filters'), groups: q$('.csr-groups'), close: q$('.csr-filters-close'), overlay: q$('.csr-overlay'),
    clearAll: q$('.csr-clear-all'), apply: q$('.csr-apply'), grid: q$('.csr-grid'), empty: q$('.csr-empty'),
    emptyTitle: q$('.csr-empty-title'), emptyChips: q$('.csr-empty-chips'), moreWrap: q$('.csr-more-wrap'), more: q$('.csr-more'), progress: q$('.csr-progress')
  };
 
  var CS, base = [], res = null;
  var state = { q: '', sort: cfg.defaultSort, sel: {}, min: null, max: null, shown: cfg.perPage };
 
  /* ------------------------------------------------------------ colors */
  var NAMED = {
    black: '#111', white: '#fff', red: '#d7263d', blue: '#2a6fdb', 'dark blue': '#1e2b50', navy: '#1e2b50', 'light blue': '#9fc8ee', 'sky blue': '#6db8e8', 'baby blue': '#bfd9f2',
    green: '#2e9e5b', 'dark green': '#2e3c2b', 'light green': '#b9e3a6', olive: '#7a7a3a', mint: '#99dbd0', 'mint green': '#99dbd0',
    pink: '#f2a7c3', 'hot pink': '#f34a7c', 'light pink': '#f5cdd8', 'baby pink': '#efafe2', purple: '#8a4fbf', lavender: '#b9a7e6', lilac: '#c8a2c8', 'dark purple': '#674265',
    yellow: '#f6d02f', orange: '#f28c28', gold: 'linear-gradient(135deg,#d9b44a,#f7e7a1,#b8902f)', silver: 'linear-gradient(135deg,#bfc3c7,#f1f2f3,#9da3a8)',
    'rose gold': 'linear-gradient(135deg,#dba7b2,#f6d5da,#c48a97)', gray: '#8c8f94', grey: '#8c8f94', 'dark gray': '#4a4d52', 'space gray': '#4a4d52',
    brown: '#7a5a3c', 'dark brown': '#362721', 'light brown': '#a87443', beige: '#eee8de', cream: '#f4ecd8', ivory: '#fffbf0', nude: '#dbbaac', khaki: '#c3b091',
    burgundy: '#85485d', maroon: '#6d1a36', wine: '#722f37', turquoise: '#40c4c4', teal: '#237388', coral: '#ff7f6e', peach: '#ffcba4',
    clear: 'repeating-conic-gradient(#e6e6e6 0 25%,#fff 0 50%) 50%/10px 10px', transparent: 'repeating-conic-gradient(#e6e6e6 0 25%,#fff 0 50%) 50%/10px 10px',
    'natural titanium': '#6c6c6c', 'black titanium': '#4c4a48', 'white titanium': '#edebe7', 'blue titanium': '#545b69', 'desert titanium': '#bfa48f',
    titanium: '#8a8d8f', multicolor: 'conic-gradient(red,orange,yellow,green,blue,purple,red)', colorful: 'conic-gradient(red,orange,yellow,green,blue,purple,red)', rainbow: 'conic-gradient(red,orange,yellow,green,blue,purple,red)',
    'اسود': '#111', 'ابيض': '#fff', 'احمر': '#d7263d', 'ازرق': '#2a6fdb', 'اخضر': '#2e9e5b', 'وردي': '#f2a7c3', 'زهري': '#f2a7c3', 'بنفسجي': '#8a4fbf', 'اصفر': '#f6d02f', 'برتقالي': '#f28c28', 'رمادي': '#8c8f94', 'بني': '#7a5a3c', 'ذهبي': '#d9b44a', 'فضي': '#bfc3c7', 'شفاف': 'repeating-conic-gradient(#e6e6e6 0 25%,#fff 0 50%) 50%/10px 10px'
  };
  var swatchCache = {};
  function swatchBg(name) {
    var k = String(name).toLowerCase().trim();
    if (swatchCache[k] !== undefined) return swatchCache[k];
    var v = (cfg.swatches && cfg.swatches[k]) || NAMED[k];
    if (!v) { /* try last word: "Matte Black" → black, "Sierra Blue" → blue */
      var words = k.split(/\s+/);
      for (var i = words.length - 1; i >= 0 && !v; i--) v = NAMED[words[i]] || (window.CSS && CSS.supports && CSS.supports('color', words[i]) ? words[i] : null);
      if (!v && window.CSS && CSS.supports && CSS.supports('color', k.replace(/\s+/g, ''))) v = k.replace(/\s+/g, '');
    }
    if (v && v.indexOf('url(') === 0) v = v + ' center/cover';
    swatchCache[k] = v || null;
    return swatchCache[k];
  }
 
  /* ---------------------------------------------------------- facets */
  function namesList(s) { return String(s || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean); }
  cfg.filters.forEach(function (f) { f.nameSet = namesList(f.names); });
  var cardColorNames = namesList(cfg.cardSwatchOption);
 
  function optValues(doc, nameSet) {
    var out = [];
    Object.keys(doc.opts || {}).forEach(function (n) { if (nameSet.indexOf(n.toLowerCase()) > -1) out = out.concat(doc.opts[n]); });
    return out;
  }
  function valuesFor(f, doc) {
    switch (f.type) {
      case 'vendor': return doc.vendor ? [doc.vendor] : [];
      case 'product_type': return doc.type ? [doc.type] : [];
      case 'color': case 'option': return optValues(doc, f.nameSet);
      case 'tag':
        var p = f.prefix.toLowerCase();
        return doc.tags.filter(function (t) { return !p || t.toLowerCase().indexOf(p) === 0; }).map(function (t) { return p ? t.slice(p.length).replace(/[_-]+/g, ' ') : t; });
      case 'availability': return doc.avail ? ['1'] : [];
      case 'sale': return doc.compare > doc.price ? ['1'] : [];
    }
    return [];
  }
  var keyOf = function (v) { return String(v).toLowerCase().trim(); };
  function passes(doc, skipId) {
    if (state.min != null && doc.price < state.min) return false;
    if (state.max != null && doc.price > state.max) return false;
    for (var i = 0; i < cfg.filters.length; i++) {
      var f = cfg.filters[i];
      if (f.id === skipId || f.type === 'price') continue;
      var sel = state.sel[f.id];
      if (!sel || !sel.length) continue;
      var vals = valuesFor(f, doc).map(keyOf);
      if (!sel.some(function (s) { return vals.indexOf(s) > -1; })) return false;
    }
    return true;
  }
  function facetCounts(f) { /* counts ignore the facet's own selection, so values stay clickable */
    var m = new Map();
    base.forEach(function (doc) {
      if (!passes(doc, f.id)) return;
      var seen = {};
      valuesFor(f, doc).forEach(function (v) {
        var k = keyOf(v); if (!k || seen[k]) return; seen[k] = 1;
        var e = m.get(k); if (!e) { e = { label: v, n: 0 }; m.set(k, e); } e.n++;
      });
    });
    return m;
  }
 
  /* ---------------------------------------------------------- URL state */
  function readUrl() {
    var p = new URLSearchParams(location.search);
    state.q = (p.get('q') || '').trim();
    state.sort = p.get('sort') || cfg.defaultSort;
    if (!sortOpt(state.sort)) { var first = el.sortMenu.querySelector('[data-sort]'); state.sort = first ? first.dataset.sort : 'relevance'; }
    if (!state.q && state.sort === 'relevance' && sortOpt('best')) state.sort = 'best';
    state.sel = {};
    cfg.filters.forEach(function (f) { var v = p.get('f_' + f.type + (f.type === 'option' || f.type === 'tag' ? '_' + slug(f.label) : '')); if (v) state.sel[f.id] = v.split(',').map(keyOf); });
    state.min = p.has('price_min') ? Math.round(parseFloat(p.get('price_min')) * 100) : null;
    state.max = p.has('price_max') ? Math.round(parseFloat(p.get('price_max')) * 100) : null;
    state.shown = cfg.perPage;
  }
  function slug(s) { return String(s).toLowerCase().replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-|-$/g, ''); }
  function writeUrl() {
    var p = new URLSearchParams();
    if (state.q) p.set('q', state.q);
    p.set('type', 'product');
    if (state.sort !== cfg.defaultSort) p.set('sort', state.sort);
    cfg.filters.forEach(function (f) { var s = state.sel[f.id]; if (s && s.length) p.set('f_' + f.type + (f.type === 'option' || f.type === 'tag' ? '_' + slug(f.label) : ''), s.join(',')); });
    if (state.min != null) p.set('price_min', (state.min / 100).toString());
    if (state.max != null) p.set('price_max', (state.max / 100).toString());
    history.replaceState(null, '', location.pathname + '?' + p.toString());
  }
 
  /* ---------------------------------------------------------- sorting */
  function sortDocs(arr) {
    var a = arr.slice();
    /* "Newest first" on a search keeps strong matches above loose ones, newest first inside each group */
    var top = 0;
    if (state.q) a.forEach(function (d) { if ((d._score || 0) > top) top = d._score || 0; });
    var tier = function (d) { return top && (d._score || 0) < top * 0.45 ? 1 : 0; };
    var by = {
      relevance: function (x, y) { return (y._score || 0) - (x._score || 0) || x.rank - y.rank; },
      best: function (x, y) { return x.rank - y.rank; },
      'price-asc': function (x, y) { return x.price - y.price || x.rank - y.rank; },
      'price-desc': function (x, y) { return y.price - x.price || x.rank - y.rank; },
      newest: function (x, y) { return tier(x) - tier(y) || y.created - x.created || x.rank - y.rank; },
      discount: function (x, y) { return disc(y) - disc(x) || x.rank - y.rank; },
      az: function (x, y) { return x.title.localeCompare(y.title); }
    }[state.sort] || function (x, y) { return x.rank - y.rank; };
    a.sort(by);
    if (cfg.soldOut === 'last') a.sort(function (x, y) { return (y.avail ? 1 : 0) - (x.avail ? 1 : 0); }); /* stable */
    return a;
  }
  function disc(d) { return d.compare > d.price ? 1 - d.price / d.compare : 0; }
 
  /* ---------------------------------------------------------- rendering */
  function esc(s) { return CS.esc(s); }
  var cardSeq = 0;
  function withVariant(url, id) { return id ? url.replace(/([?&])variant=\d+&?/, '$1').replace(/[?&]$/, '') + (url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + id : url; }
  function priceHtml(d) { /* same markup as the theme's product cards, so font, size and colors match */
    var from = d.priceMax > d.price ? esc(T.from) + ' ' : '';
    if (d.compare > d.price) {
      return '<span class="price price--highlight"><span class="visually-hidden">' + esc(T.salePrice) + '</span>' + from + esc(CS.money(d.price)) + '</span>' +
        '<span class="price price--compare"><span class="visually-hidden">' + esc(T.regularPrice) + '</span>' + esc(CS.money(d.compare)) + '</span>';
    }
    return '<span class="price"><span class="visually-hidden">' + esc(T.salePrice) + '</span>' + from + esc(CS.money(d.price)) + '</span>';
  }
  function card(d) {
    var sale = d.compare > d.price, pct = sale ? Math.round(disc(d) * 100) : 0, url = CS.productUrl(d), n = ++cardSeq;
    var badge = !d.avail ? '<span class="csr-badge csr-badge--out">' + esc(T.soldOut) + '</span>' : (pct >= 5 ? '<span class="csr-badge">-' + pct + '%</span>' : '');
    var sw = '';
    if (cfg.cardSwatches) {
      var cols = optValues(d, cardColorNames), shown = cols.slice(0, 8);
      if (cols.length > 1) {
        sw = '<div class="product-item-meta__swatch-list color-swatch-list color-swatch-list--mini csr-card-sw">' + shown.map(function (c, i) {
          var bg = swatchBg(c), id = 'csr-sw-' + n + '-' + i, white = /^(white|ابيض|أبيض)$/i.test(String(c).trim());
          return '<div class="color-swatch' + (white ? ' color-swatch--white' : '') + '"><input class="color-swatch__radio visually-hidden" type="radio" name="csr-sw-' + n + '" id="' + id + '" value="' + esc(c) + '">' +
            '<label class="color-swatch__item" for="' + id + '" title="' + esc(c) + '" style="background:' + esc(bg || '#ddd') + '"><span class="visually-hidden">' + esc(c) + '</span></label></div>';
        }).join('') + (cols.length > 8 ? '<a class="csr-sw-more" href="' + esc(url) + '">+' + (cols.length - 8) + '</a>' : '') + '</div>';
      }
    }
    var img = d.img ? '<img src="' + esc(CS.imgUrl(d.img, 400)) + '" srcset="' + esc(CS.imgUrl(d.img, 300)) + ' 300w, ' + esc(CS.imgUrl(d.img, 500)) + ' 500w, ' + esc(CS.imgUrl(d.img, 700)) + ' 700w" sizes="(min-width:1000px) 22vw, 48vw" alt="' + esc(d.title) + '" loading="lazy" decoding="async" onload="this.parentNode.classList.add(\'is-loaded\')">' : '';
    return '<div class="csr-card' + (d.avail ? '' : ' is-out') + '" data-handle="' + esc(d.handle) + '" data-url="' + esc(url) + '">' +
      '<a class="csr-img" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' + badge + img + '</a>' +
      '<div class="csr-info product-item__info"><div class="product-item-meta">' +
      (cfg.showVendor && d.vendor ? '<span class="product-item-meta__vendor heading heading--xsmall">' + esc(d.vendor) + '</span>' : '') +
      '<a class="product-item-meta__title" href="' + esc(url) + '">' + esc(d.title) + '</a>' +
      '<div class="product-item-meta__price-list-container"><div class="price-list price-list--centered">' + priceHtml(d) + '</div></div>' +
      sw + '</div></div></div>';
  }
 
  /* ---------------------------------------------------------- card color swatches */
  var productCache = {};
  function getProduct(handle) {
    if (!productCache[handle]) {
      var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      productCache[handle] = fetch(rootUrl + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function (e) { delete productCache[handle]; throw e; });
    }
    return productCache[handle];
  }
  function sizedImg(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '') + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function showColor(cardEl, color) {
    return getProduct(cardEl.dataset.handle).then(function (p) {
      var want = keyOf(color), idx = -1;
      (p.options || []).forEach(function (o, i) { var nm = keyOf(o.name || o); if (idx < 0 && cardColorNames.indexOf(nm) > -1) idx = i; });
      if (idx < 0) return;
      var key = 'option' + (idx + 1);
      var matches = (p.variants || []).filter(function (v) { return keyOf(v[key]) === want; });
      if (!matches.length) return;
      var v = matches.filter(function (x) { return x.available; })[0] || matches[0];
      var withImg = matches.filter(function (x) { return x.featured_image; })[0];
      var src = (v.featured_image || (withImg && withImg.featured_image) || {}).src;
      var imgEl = cardEl.querySelector('.csr-img img');
      if (src && imgEl) {
        var next = new Image();
        next.onload = function () {
          imgEl.removeAttribute('srcset');
          imgEl.src = next.src;
        };
        next.src = sizedImg(src, 500);
      }
      var url = withVariant(cardEl.dataset.url, v.id);
      cardEl.querySelectorAll('a.csr-img, a.product-item-meta__title, a.csr-sw-more').forEach(function (a) { a.href = url; });
      var r = cardEl.querySelector('.color-swatch__radio[value="' + (window.CSS && CSS.escape ? CSS.escape(color) : color) + '"]');
      if (r) r.checked = true;
    }).catch(function () {});
  }
  function colorFilterKeys() {
    var keys = [];
    cfg.filters.forEach(function (f) { if (f.type === 'color' && state.sel[f.id]) keys = keys.concat(state.sel[f.id]); });
    return keys;
  }
  function syncCardColors(cards) { /* a color filter is on: show each card in that color */
    var keys = colorFilterKeys();
    if (!keys.length) return;
    cards.forEach(function (c) {
      var radios = c.querySelectorAll('.color-swatch__radio');
      for (var i = 0; i < radios.length; i++) {
        if (keys.indexOf(keyOf(radios[i].value)) > -1) { radios[i].checked = true; showColor(c, radios[i].value); break; }
      }
    });
  }
 
  function renderFilters() {
    var activeChips = [];
    cfg.filters.forEach(function (f) {
      var g = root.querySelector('.csr-group[data-block-id="' + f.id + '"]');
      if (!g) return;
      var body = g.querySelector('.csr-group-body'), nEl = g.querySelector('.csr-group-n');
      var sel = state.sel[f.id] || [];
      if (f.type === 'price') {
        var prices = base.filter(function (d) { return passes(d, null) || true; }).map(function (d) { return d.price; });
        if (!prices.length) { g.hidden = true; return; }
        var lo = Math.floor(Math.min.apply(null, prices) / 100), hi = Math.ceil(Math.max.apply(null, prices) / 100);
        g.hidden = hi <= lo;
        var curLo = state.min != null ? state.min / 100 : lo, curHi = state.max != null ? state.max / 100 : hi;
        if (!body.querySelector('.csr-range') || body.dataset.lo != lo || body.dataset.hi != hi) {
          body.dataset.lo = lo; body.dataset.hi = hi;
          body.innerHTML = '<div class="csr-range"><div class="csr-range-track"><span class="csr-range-fill"></span></div>' +
            '<input type="range" class="csr-r-min" min="' + lo + '" max="' + hi + '" step="1" value="' + curLo + '" aria-label="' + esc(T.from) + '">' +
            '<input type="range" class="csr-r-max" min="' + lo + '" max="' + hi + '" step="1" value="' + curHi + '" aria-label="' + esc(T.to) + '"></div>' +
            '<div class="csr-range-inputs"><label>' + esc(T.from) + '<input type="number" class="csr-n-min" min="' + lo + '" max="' + hi + '" value="' + curLo + '"></label><span>—</span><label>' + esc(T.to) + '<input type="number" class="csr-n-max" min="' + lo + '" max="' + hi + '" value="' + curHi + '"></label></div>';
        } else {
          body.querySelector('.csr-r-min').value = curLo; body.querySelector('.csr-r-max').value = curHi;
          body.querySelector('.csr-n-min').value = curLo; body.querySelector('.csr-n-max').value = curHi;
        }
        paintRange(body);
        if (state.min != null || state.max != null) {
          nEl.hidden = false; nEl.textContent = '•';
          activeChips.push({ id: 'price', label: CS.money(Math.round(curLo * 100)) + ' – ' + CS.money(Math.round(curHi * 100)) });
        } else nEl.hidden = true;
        return;
      }
      var counts = facetCounts(f);
      if (f.type === 'availability' || f.type === 'sale') {
        var c = counts.get('1'), on = sel.indexOf('1') > -1;
        g.hidden = !c && !on;
        body.innerHTML = '<label class="csr-check"><input type="checkbox" data-f="' + f.id + '" value="1"' + (on ? ' checked' : '') + '><span>' + esc(f.type === 'sale' ? T.onSale : T.inStock) + '</span>' + (f.showCounts && c ? '<i>' + c.n + '</i>' : '') + '</label>';
        nEl.hidden = !on; nEl.textContent = '•';
        if (on) activeChips.push({ id: f.id, v: '1', label: f.type === 'sale' ? T.onSale : T.inStock });
        return;
      }
      sel.forEach(function (s) { if (!counts.has(s)) counts.set(s, { label: s, n: 0 }); });
      var vals = Array.from(counts.entries()).map(function (e) { return { k: e[0], label: e[1].label, n: e[1].n }; });
      vals.sort(function (a, b) { return (sel.indexOf(b.k) > -1) - (sel.indexOf(a.k) > -1) || b.n - a.n || a.label.localeCompare(b.label, undefined, { numeric: true }); });
      if (f.type === 'option') vals.sort(function (a, b) { return (sel.indexOf(b.k) > -1) - (sel.indexOf(a.k) > -1) || b.label.localeCompare(a.label, undefined, { numeric: true }); }); /* newest models first */
      g.hidden = !vals.length || (f.hideSingle && vals.length < 2 && !sel.length);
      var expanded = g.dataset.expanded === '1', limit = expanded ? 1e9 : f.max;
      var isSw = f.type === 'color' && f.display !== 'list';
      var html = '<div class="csr-values csr-values--' + (isSw ? (f.display === 'swatch' ? 'swatch' : 'swatch-list') : (f.display === 'pills' ? 'pills' : 'list')) + '">';
      vals.slice(0, limit).forEach(function (v) {
        var on = sel.indexOf(v.k) > -1, dis = !v.n && !on;
        if (isSw) {
          var bg = swatchBg(v.label);
          html += '<label class="csr-sw' + (on ? ' is-on' : '') + (dis ? ' is-dis' : '') + '" title="' + esc(v.label) + (f.showCounts ? ' (' + v.n + ')' : '') + '"><input type="checkbox" data-f="' + f.id + '" value="' + esc(v.k) + '"' + (on ? ' checked' : '') + (dis ? ' disabled' : '') + '>' +
            '<span class="csr-sw-dot' + (bg ? '' : ' is-unknown') + '" style="background:' + esc(bg || '#e9eef0') + '">' + (bg ? '' : esc(v.label.charAt(0))) + '</span>' +
            (f.display === 'swatch_list' ? '<span class="csr-sw-name">' + esc(v.label) + '</span>' + (f.showCounts ? '<i>' + v.n + '</i>' : '') : '') + '</label>';
        } else {
          html += '<label class="csr-check' + (dis ? ' is-dis' : '') + '"><input type="checkbox" data-f="' + f.id + '" value="' + esc(v.k) + '"' + (on ? ' checked' : '') + (dis ? ' disabled' : '') + '><span>' + esc(v.label) + '</span>' + (f.showCounts ? '<i>' + v.n + '</i>' : '') + '</label>';
        }
        if (on) activeChips.push({ id: f.id, v: v.k, label: v.label, sw: isSw ? swatchBg(v.label) : null });
      });
      html += '</div>';
      if (vals.length > f.max) html += '<button type="button" class="csr-toggle" data-expand="' + f.id + '">' + esc(expanded ? T.showLess : T.showMore + ' (' + (vals.length - f.max) + ')') + '</button>';
      body.innerHTML = html;
      nEl.hidden = !sel.length; nEl.textContent = sel.length;
    });
    el.active.innerHTML = activeChips.map(function (c) {
      return '<button type="button" class="csr-chip" data-remove="' + esc(c.id) + '" data-v="' + esc(c.v || '') + '">' + (c.sw ? '<i style="background:' + esc(c.sw) + '"></i>' : '') + esc(c.label) + '<span aria-hidden="true">×</span></button>';
    }).join('') + (activeChips.length > 1 ? '<button type="button" class="csr-chip csr-chip--clear" data-remove="*">' + esc(el.clearAll.textContent) + '</button>' : '');
    el.filterCount.hidden = !activeChips.length; el.filterCount.textContent = activeChips.length;
  }
  function paintRange(body) {
    var a = body.querySelector('.csr-r-min'), b = body.querySelector('.csr-r-max'), fill = body.querySelector('.csr-range-fill');
    if (!a) return;
    var lo = +a.min, hi = +a.max, span = Math.max(1, hi - lo);
    var l = (Math.min(+a.value, +b.value) - lo) / span * 100, r = (Math.max(+a.value, +b.value) - lo) / span * 100;
    fill.style.insetInlineStart = l + '%'; fill.style.width = (r - l) + '%';
  }
 
  function render() {
    var list = sortDocs(base.filter(function (d) { return passes(d, null) && !(cfg.soldOut === 'hide' && !d.avail); }));
    root.removeAttribute('data-loading');
    renderFilters();
    if (state.q) {
      el.title.innerHTML = esc(T.resultsFor) + ' <q>' + esc(state.q) + '</q>';
      document.title = T.resultsFor + ' “' + state.q + '” – ' + (CS.cfg.shop || 'Catchyjo');
    } else el.title.textContent = T.all;
    el.sub.textContent = list.length + ' ' + T.products + (res && res.relaxed ? ' · ' + T.close : '');
    if (res && res.correction && res.total) {
      el.dym.hidden = false;
      el.dym.innerHTML = esc(T.showingFor) + ' <b>' + esc(res.correction) + '</b>';
    } else el.dym.hidden = true;
    el.apply.textContent = T.apply.replace('{n}', list.length);
 
    if (!list.length) {
      el.grid.innerHTML = ''; el.moreWrap.hidden = true; el.empty.hidden = false;
      el.emptyTitle.textContent = T.noResults + ' “' + (state.q || '') + '”';
      var pop = Array.prototype.map.call(document.querySelectorAll('#cs-root .cs-popular-list [data-cs-term]'), function (b) { return b.dataset.csTerm; }).slice(0, 8);
      el.emptyChips.innerHTML = pop.map(function (t) { return '<a class="csr-chip" href="' + esc(CS.cfg.searchUrl + '?q=' + encodeURIComponent(t) + '&type=product') + '">' + esc(t) + '</a>'; }).join('');
      return;
    }
    el.empty.hidden = true;
    el.grid.innerHTML = list.slice(0, state.shown).map(function (d) { return card(d); }).join('');
    syncCardColors(Array.prototype.slice.call(el.grid.children));
    el.moreWrap.hidden = list.length <= cfg.perPage;
    var shown = Math.min(state.shown, list.length);
    el.progress.textContent = T.showing.replace('{x}', shown).replace('{y}', list.length);
    el.progress.style.setProperty('--p', (shown / list.length * 100) + '%');
    el.more.hidden = shown >= list.length;
    el.more.textContent = T.more;
  }
 
  function compute() {
    if (state.q) {
      res = CS.query(state.q);
      base = res.all;
      if (!base.length) { /* last resort: search each word on its own */
        CS.tokens(state.q, true).some(function (t) { var r = CS.query(t); if (r.total) { res = r; res.relaxed = true; base = r.all; return true; } });
      }
    } else { res = null; base = CS.docs().slice(); }
  }
  function update(opts) {
    state.shown = cfg.perPage;
    render(); writeUrl();
    if (!(opts && opts.keepScroll) && window.matchMedia('(min-width: 1000px)').matches) {
      var top = root.getBoundingClientRect().top + window.scrollY - 120;
      if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }
 
  /* ---------------------------------------------------------- sort menu */
  function sortOpt(v) { return el.sortMenu.querySelector('[data-sort="' + v + '"]'); }
  function sortUI() {
    el.sortMenu.querySelectorAll('[data-sort]').forEach(function (o) { o.setAttribute('aria-selected', o.dataset.sort === state.sort); });
    var cur = sortOpt(state.sort);
    el.sortCur.textContent = cur ? cur.querySelector('.csr-sort-ot').textContent : '';
  }
  function setSort(v) { if (v === state.sort) return; state.sort = v; sortUI(); update(); }
  function sortMenu(open) {
    el.sortMenu.hidden = !open; el.sortScrim.hidden = !open;
    el.sortBtn.setAttribute('aria-expanded', open);
    el.sortWrap.classList.toggle('is-open', open);
    root.classList.toggle('is-sorting', open);
    var sheet = window.matchMedia('(max-width: 749px)').matches;
    document.documentElement.classList.toggle('cs-lock', open && sheet);
    if (open) { var cur = sortOpt(state.sort) || el.sortMenu.querySelector('[data-sort]'); if (cur) cur.focus({ preventScroll: true }); }
  }
  document.addEventListener('click', function (e) { if (!el.sortMenu.hidden && !el.sortWrap.contains(e.target)) sortMenu(false); });
  el.sortWrap.addEventListener('keydown', function (e) {
    if (el.sortMenu.hidden) { if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && e.target === el.sortBtn) { e.preventDefault(); sortMenu(true); } return; }
    var opts = Array.prototype.slice.call(el.sortMenu.querySelectorAll('[data-sort]')), i = opts.indexOf(document.activeElement);
    if (e.key === 'Escape') { sortMenu(false); el.sortBtn.focus(); }
    else if (e.key === 'ArrowDown') { e.preventDefault(); opts[(i + 1) % opts.length].focus(); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); opts[(i - 1 + opts.length) % opts.length].focus(); }
    else if (e.key === 'Tab') sortMenu(false);
  });
 
  /* ---------------------------------------------------------- events */
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-f]')) {
      var id = t.dataset.f, cur = state.sel[id] || [];
      state.sel[id] = t.checked ? cur.concat(t.value) : cur.filter(function (x) { return x !== t.value; });
      update({ keepScroll: true });
    } else if (t.matches('.csr-card .color-swatch__radio')) { showColor(t.closest('.csr-card'), t.value); }
    else if (t.matches('.csr-r-min,.csr-r-max,.csr-n-min,.csr-n-max')) { setPriceFrom(t); update({ keepScroll: true }); }
  });
  root.addEventListener('input', function (e) {
    if (e.target.matches('.csr-r-min,.csr-r-max')) {
      var body = e.target.closest('.csr-group-body');
      var a = body.querySelector('.csr-r-min'), b = body.querySelector('.csr-r-max');
      if (+a.value > +b.value) { if (e.target === a) a.value = b.value; else b.value = a.value; }
      body.querySelector('.csr-n-min').value = a.value; body.querySelector('.csr-n-max').value = b.value;
      paintRange(body);
    }
  });
  function setPriceFrom(t) {
    var body = t.closest('.csr-group-body'), lo = +body.dataset.lo, hi = +body.dataset.hi;
    var isNum = t.classList.contains('csr-n-min') || t.classList.contains('csr-n-max');
    var a = +(isNum ? body.querySelector('.csr-n-min') : body.querySelector('.csr-r-min')).value;
    var b = +(isNum ? body.querySelector('.csr-n-max') : body.querySelector('.csr-r-max')).value;
    if (a > b) { var x = a; a = b; b = x; }
    state.min = a > lo ? Math.round(a * 100) : null;
    state.max = b < hi ? Math.round(b * 100) : null;
  }
  root.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove]');
    if (rm) {
      var id = rm.dataset.remove;
      if (id === '*') { state.sel = {}; state.min = state.max = null; }
      else if (id === 'price') { state.min = state.max = null; }
      else state.sel[id] = (state.sel[id] || []).filter(function (x) { return x !== rm.dataset.v; });
      update({ keepScroll: true }); return;
    }
    var ex = e.target.closest('[data-expand]');
    if (ex) { var g = ex.closest('.csr-group'); g.dataset.expanded = g.dataset.expanded === '1' ? '0' : '1'; renderFilters(); return; }
    if (e.target.closest('.csr-more')) { state.shown += cfg.perPage; render(); return; }
    var srt = e.target.closest('.csr-sort-opt');
    if (srt) { setSort(srt.dataset.sort); sortMenu(false); el.sortBtn.focus(); return; }
    if (e.target.closest('.csr-sort-btn')) { sortMenu(el.sortMenu.hidden); return; }
    if (e.target.closest('.csr-sort-close, .csr-sort-scrim')) { sortMenu(false); return; }
    if (e.target.closest('.csr-card a') && state.q) { CS.remember(state.q); CS.log(state.q, base.length, 'results-click'); }
  });
  el.clearAll.addEventListener('click', function () { state.sel = {}; state.min = state.max = null; update({ keepScroll: true }); });
  function drawer(open) {
    root.classList.toggle('is-drawer', open);
    el.overlay.hidden = !open;
    el.filterBtn.setAttribute('aria-expanded', open);
    document.documentElement.classList.toggle('cs-lock', open);
  }
  el.filterBtn.addEventListener('click', function () { drawer(!root.classList.contains('is-drawer')); });
  el.close.addEventListener('click', function () { drawer(false); });
  el.apply.addEventListener('click', function () { drawer(false); });
  el.overlay.addEventListener('click', function () { drawer(false); });
  el.searchForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = el.searchInput.value.trim(); if (!v) return;
    CS.remember(v);
    state.q = v; state.sel = {}; state.min = state.max = null; state.sort = cfg.defaultSort;
    if (!sortOpt(state.sort)) state.sort = (el.sortMenu.querySelector('[data-sort]') || { dataset: { sort: 'relevance' } }).dataset.sort;
    sortUI(); compute(); update(); CS.log(v, base.length, 'results');
  });
  window.addEventListener('popstate', function () { readUrl(); sortUI(); compute(); render(); });
  /* prefetch product data when a shopper heads for the swatches, so the color switch is instant */
  root.addEventListener('pointerover', function (e) {
    var l = e.target.closest && e.target.closest('.csr-card-sw');
    if (l) getProduct(l.closest('.csr-card').dataset.handle).catch(function () {});
  });
 
  /* ---------------------------------------------------------- start */
  function start() {
    CS = window.CatchySearch;
    readUrl();
    el.searchInput.value = state.q;
    sortUI();
    CS.ready().then(function () {
      compute(); render();
      if (state.q) CS.log(state.q, base.length, 'results');
    }).catch(function () {
      root.removeAttribute('data-loading');
      el.grid.innerHTML = '<p class="csr-error">' + esc(T.error) + ' <button type="button" onclick="location.reload()">' + esc(T.retry) + '</button></p>';
    });
  }
  if (window.CatchySearch) start(); else document.addEventListener('catchy-search:ready', start, { once: true });
})();